import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';

import { contentVerifiedBlue, paleBlue, warmGray } from 'lib/css/colors';
import DuplicateBrandsProductsModal from 'components/manage_brands/DuplicateBrandsProductsModal';
import { GLOBAL_VENDORS_FOR_DROPDOWN } from 'lib/networking/endpoints';
import sharedStyles from 'components/manage_brands/brand_verify/sharedStyles';
import useGet from 'lib/hooks/useGet';

function DistributorsList({ brand, totalProductCount, defaultVisibleCount }) {
  const [showBrandProductsModal, setShowBrandProductsModal] = useState(false);
  const [globalVendorId, setGlobalVendorId] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const { data: { data: globalVendors } = {} } = useGet(GLOBAL_VENDORS_FOR_DROPDOWN, {
    brand_id: brand?.id,
  });
  const totalDistributors = globalVendors?.length ?? 0;
  const hasOverflow = totalDistributors > defaultVisibleCount;
  const visibleDistributors =
    hasOverflow && !isExpanded ? globalVendors.slice(0, defaultVisibleCount) : globalVendors;
  return (
    <>
      <div className="mb-3">
        <div className={css(sharedStyles.fieldLabel)}>
          DISTRIBUTORS - {totalProductCount} PRODUCTS TOTAL
        </div>
        <div className={css(styles.distributorsContainer)}>
          {visibleDistributors?.map(distributor => (
            <span
              key={distributor.id}
              className={css(styles.distributorChip)}
              onClick={() => {
                setGlobalVendorId(distributor.id);
                setShowBrandProductsModal(true);
              }}
            >
              {distributor.name}
            </span>
          ))}
          {hasOverflow ? (
            <span className={css(styles.toggleChip)} onClick={() => setIsExpanded(prev => !prev)}>
              {isExpanded
                ? 'Show less'
                : `Show all (${totalDistributors - defaultVisibleCount} more)`}
            </span>
          ) : null}
        </div>
        <div className={css(styles.distributorHint)}>Click a distributor to view its products</div>
      </div>
      {showBrandProductsModal ? (
        <DuplicateBrandsProductsModal
          brand={brand}
          globalVendorId={globalVendorId}
          onHide={() => setShowBrandProductsModal(false)}
        />
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  distributorsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  distributorChip: {
    backgroundColor: paleBlue,
    color: contentVerifiedBlue,
    padding: '4px 12px',
    borderRadius: 16,
    fontSize: '0.8rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
  toggleChip: {
    backgroundColor: 'transparent',
    color: contentVerifiedBlue,
    padding: '4px 12px',
    borderRadius: 16,
    fontSize: '0.8rem',
    fontWeight: 600,
    cursor: 'pointer',
    border: `1px dashed ${contentVerifiedBlue}`,
  },
  distributorHint: {
    color: warmGray,
    fontSize: '0.75rem',
    marginTop: 6,
  },
});

DistributorsList.propTypes = {
  brand: PropTypes.object.isRequired,
  totalProductCount: PropTypes.number.isRequired,
  defaultVisibleCount: PropTypes.number,
};

DistributorsList.defaultProps = {
  defaultVisibleCount: 5,
};

export default DistributorsList;
